import * as React from "react";

import { formatPropertyStatus, Property } from "@/types/property";

export const PropertyStatusDetails: React.FC<{ property: Property }> = ({ property }) => {
  return <span>{formatPropertyStatus(property.status)}. </span>;
};
